/* Light/dark toggle.
   The initial value is resolved inline in default.hbs before first paint; this
   only handles the toggle and keeps 'auto' in step with the OS. */
(function () {
    const root = document.documentElement;
    const STORAGE_KEY = 'crpg-theme';
    const media = window.matchMedia('(prefers-color-scheme: light)');

    function stored() {
        try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    }

    function persist(value) {
        try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* private mode */ }
    }

    function apply(theme) {
        root.setAttribute('data-theme', theme);
        document.querySelectorAll('.gh-theme-toggle').forEach(function (button) {
            button.setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
        });
    }

    /* Follow the OS only while the reader has not chosen for themselves. */
    function onSystemChange() {
        if (stored()) return;
        if (root.dataset.themeDefault === 'auto') {
            apply(media.matches ? 'light' : 'dark');
        }
    }

    if (media.addEventListener) {
        media.addEventListener('change', onSystemChange);
    } else if (media.addListener) {
        media.addListener(onSystemChange);
    }

    document.querySelectorAll('.gh-theme-toggle').forEach(function (button) {
        button.addEventListener('click', function () {
            const next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
            persist(next);
            apply(next);
        });
    });

    apply(root.getAttribute('data-theme') || 'dark');
})();
